export const rules = {
  xl: `min(1280px, 90vw)`,
  lg: `min(1024px, 90vw)`,
  md: `min(768px, 90vw)`,
  sm: `min(640px, 90vw)`,
};
